import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX, memo, useMemo} from "react";

interface MaterialIconProps {
	className?: string;
	icon: string;
	title?: string;
}

function MaterialIconD({icon, title, className}: MaterialIconProps): JSX.Element {
	const cn = useMemo(() => `material-symbols-rounded decoration-icon${className ? " " + className : ""}`, [className]);

	if (isNullOrEmpty(title)) {
		return <span className={cn} aria-hidden={true}>{icon}</span>;
	}

	return <span className={cn} title={title} aria-label={title}>{icon}</span>;
}

const MaterialIcon = memo(MaterialIconD);
export default MaterialIcon;
